import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import MfprintingtypeFilterCriteria from './MfprintingtypeFilterCriteria'
import MfprintingtypeList from './MfprintingtypeList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './MfprintingtypeAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setMfprintingtypeDashboardMfprintingtypeList } from '../../store/slice/ManufSlice';

export default function MfprintingtypeListView({setShowEdit,setMfprintingtypeId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.mfprintingtypeDashboard);   

    const [filteredMfprintingtypeList, setFilteredMfprintingtypeList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { mfprintingtypeDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (mfprintingtypeDashboard.mfprintingtypeList.length>-1){
        setFilteredMfprintingtypeList(mfprintingtypeDashboard.mfprintingtypeList);
        transformToCardFormat(mfprintingtypeDashboard.mfprintingtypeList, setCardList);
      }
    },[mfprintingtypeDashboard.mfprintingtypeList])

    useEffect(()=>{
          transformToCardFormat(filteredMfprintingtypeList, setCardList);
      },[filteredMfprintingtypeList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredMfprintingtypeList(mfprintingtypeDashboard.mfprintingtypeList);
            transformToCardFormat(mfprintingtypeDashboard.mfprintingtypeList, setCardList);

        } else {
            setFilteredMfprintingtypeList(
                mfprintingtypeDashboard.mfprintingtypeList
                    .filter(mfprintingtype=> mfprintingtype.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(mfprintingtypeDashboard.filteredMfprintingtypeList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <MfprintingtypeList
                    setShowEdit={setShowEdit}
                    setMfprintingtypeId = {setMfprintingtypeId}
                    tableList={filteredMfprintingtypeList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}